import React, { Fragment, useEffect, useState } from 'react';
import DataTable from 'react-data-table-component';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

import { editarBreadcrumb } from '../../../actions/breadcrumb';
import { buscarPaquetes, filtrarPaquetes } from '../../../actions/paquetes';

import EliminarPaquete from './EliminarPaquete';
import FiltrosPaquete from './FiltrosPaquete';

const Paquetes = () => {

    let rutasBread = [
        {
            activo: true,
            nombre: 'Paquetes',
            path: '/configuracion/paquetes'
        }
    ];

    const dispatch = useDispatch();

    const { usuario } = useSelector(state => state.auth);
    const { listado } = useSelector(state => state.paquetes);

    const [paquetes, setPaquetes] = useState([]);

    const [paqueteEliminar, setPaqueteEliminar] = useState(null);

    const paginationOptions = { rowsPerPageText: 'Filas por página', rangeSeparatorText: 'de' };

    const columns = [
        {
            name: 'Nombre',
            selector: row => row.nombre,
            grow: 2
        },
        {
            name: 'Descripción',
            selector: row => row.descripcion || 'Sin descripción',
            grow: 3
        },
        {
            name: 'Productos',
            selector: row => row.total_productos || 0
        },
        {
            name: 'Servicios',
            selector: row => row.total_servicios || 0
        },
        {
            name: '',
            cell: row => {
                return (
                    <div className="text-right w-100">
                        {
                            usuario?.permisos?.paquetes?.eliminar &&
                                <button type="button" className="btn btn-sm btn-link px-2 float-end" onClick={() => handleEliminarPaquete(row)}><i className="fas fa-trash text-danger"></i></button>
                        }
                        {
                            usuario?.permisos?.paquetes?.editar &&
                                <Link className="btn btn-sm btn-link px-2 float-end" to={`/configuracion/paquetes/editar/${row.id}`}><i className="fas fa-edit text-warning"></i></Link>
                        }
                    </div>
                )
            }
        }
    ];

    const handleEliminarPaquete = (paquete) => {
        setPaqueteEliminar(paquete);
    }

    useEffect(() => {
        dispatch(buscarPaquetes({
            nombre: null, 
            descripcion: null
        }));
    }, []);

    useEffect(() => {
        setPaquetes(listado);
    }, [listado]);

    useEffect(() => {
        dispatch(editarBreadcrumb(rutasBread));
    }, [rutasBread]);

    return (
        <Fragment>

            <FiltrosPaquete />
            <EliminarPaquete paquete={paqueteEliminar} reestablecerPaquete={setPaqueteEliminar} />

            <div className="row">
                <div className="col-md-12 px-4 pb-4">
                    <h3 className="mb-3 mt-5">Paquetes</h3>

                    <div className="d-flex justify-content-end">
                        <button type="button" className="btn btn-secondary me-2" onClick={() => dispatch(filtrarPaquetes(true))}>Filtros de búsqueda</button>
                        {
                            usuario?.permisos?.paquetes?.agregar &&
                                <Link to="/configuracion/paquetes/nuevo">
                                    <button className="btn btn-primary">Agregar paquete</button>
                                </Link>
                        }
                    </div>

                    <div className="mt-2">
                        <DataTable
                            columns={columns}
                            data={paquetes}
                            pagination
                            paginationPerPage={20}
                            paginationRowsPerPageOptions={[5, 10, 20, 50]}
                            paginationComponentOptions={paginationOptions}
                            highlightOnHover={true}
                        />
                    </div>
                </div>
            </div>
        </Fragment>
    )
}

export default Paquetes;
